import { MdOutlineCheck } from "react-icons/md";

interface IStepItem {
    title:string;
    description:string;
}
interface Props {
    steps: IStepItem[];
    activeStep: number;
}
const FormStepper:React.FC<Props> = ({steps, activeStep}:Props) =>{

    const renderIndicator = (index:number) => (
        <div className="h-full flex flex-col items-center">
            <div>
                <div className={`flex items-center justify-center border border-black w-10 h-10 rounded-full ${index === activeStep && 'bg-black'}`}>
                    {
                        index < activeStep ? 
                            <div className="w-full h-full bg-black rounded-full flex items-center justify-center">
                                <MdOutlineCheck className=" fill-white h-6 w-6" />
                            </div>:
                            <div className={`h-4 w-4 rounded-full ${index === activeStep ? 'bg-white':'bg-black'}`} />
                    }
                </div>
            </div>
            {index !== steps.length - 1 &&<div className="w-[1px] h-full bg-black"/>}
        </div>
        
    );

    const renderTitleDescription = (step:IStepItem) => (
        <div className="ml-5">
            <p className="font-medium text-black">{step.title}</p>
            <p className="opacity-[80%] text-black text-[14px]">{step.description}</p>
        </div>
    );

   

    const renderStep = (step:IStepItem,index:number) => (
        <div className={`flex items-start h-[100px]`}>
            {renderIndicator(index)}
            {renderTitleDescription(step)}
        </div>
    );
  return (
    <div className="w-full h-full bg-primary rounded-xl text-black font-montserrat py-8 pl-8 pr-4">
        <div>
            <h2 className="font-semibold text-[32px] text-black">BI Educational Support</h2>
            <p className="font-medium text-[18px] text-black pt-2 opacity-[0.7]">Eligibility Check</p>
        </div>
        <div className="mt-12">
            {
                steps.map((step,index)=>(
                    <div key={index}>
                        {
                            (index < activeStep) ? renderStep(step,index):
                            (index === activeStep) ?renderStep(step,index):renderStep(step,index)
                        }
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default FormStepper;
